export default {"src":"/_next/static/media/red-heart-mobile-view-icon.6cb7db63.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};